// Placeholder — will be wired to documents.activeJobs in the document processing phase
const NavbarProgressBar = () => null;

export default NavbarProgressBar;